import React from 'react';

import * as style from './playerWidgetSkeletonStyle';
const playerWidgetSkeletonLoader: React.FC = () => {
  return <div css={style.playerWidgetSkeletonWrapper}></div>;
};

export default playerWidgetSkeletonLoader;
